export default {
  action_required: 'Aksi dibutuhkan',
  load_more: 'Muat selanjutnya',
  mark_all_as_read: 'Semua sudah dibaca',
  notification: 'Notifikasi',
  notifications: 'Notifikasi',
  today: 'Hari ini',
  updates: 'Pembaruan'
};